const zhTW = {
  "nav.home": "首頁",
  "nav.about": "品牌介紹",
  "nav.goToSongbo": "前往崧博官網",

  "footer.tagline": "崧博出版事業有限公司經銷品牌",
  "footer.subtitle": "人文歷史與經典文本的再整理品牌",
  "footer.goToSongbo": "前往崧博官網",
  "footer.copyright": "© {{year}} 複刻文化 Fuko. All Rights Reserved.",

  "home.hero.subtitle": "崧博出版事業有限公司 經銷品牌",
  "home.hero.brand": "複刻文化",
  "home.hero.tagline": "讓經典重新被閱讀",
  "home.hero.cta": "前往崧博官網",

  "home.brandIntro.imageTitle": "複刻文化",
  "home.brandIntro.imageSubtitle": "重新整理，重新詮釋",
  "home.brandIntro.label": "品牌主張",
  "home.brandIntro.heading": "人文歷史與經典文本的再整理品牌",
  "home.brandIntro.p1": "<0>複刻文化 Fuko</0> 是崧博出版經銷品牌，聚焦經典文本、歷史記憶與知識再詮釋。專注於歷史、人文社科、公版經典與小說類書籍的出版。",
  "home.brandIntro.p2": "我們相信，經典不應只存在於學術殿堂的書架上。透過重新整理、詮釋與包裝，讓這些跨越時代的文本在當代煥發新生。",
  "home.brandIntro.statBooks": "已出版書籍",
  "home.brandIntro.statAuthors": "合作作者",
  "home.brandIntro.learnMore": "了解更多",

  "home.featured.label": "精選出版",
  "home.featured.heading": "近期出版品",
  "home.featured.subtitle": "每一本書都是對經典的重新詮釋，為當代讀者搭建通往歷史與文學的橋樑。",
  "home.featured.viewAll": "前往崧博官網查看完整書目",

  "home.cta.heading": "在崧博官網，發現更多經典",
  "home.cta.subtitle": "複刻文化全系列出版品、最新書訊與完整書目，都在崧博出版官網。從歷史到文學，從公版經典到當代創作，一站探索。",
  "home.cta.button": "前往崧博官網",

  "home.relationship.label": "品牌關係",
  "home.relationship.heading": "複刻文化 × 崧博出版",
  "home.relationship.p1": "<0>複刻文化</0>為崧博出版事業有限公司經銷品牌。崧博出版擁有二十餘年的專業出版經驗，在文史類書籍領域具備深厚的編輯實力與通路資源。複刻文化借助這份專業底蘊，專注於人文歷史與經典文本的再整理。",

  "about.hero.label": "About",
  "about.hero.heading": "品牌介紹",
  "about.hero.subtitle": "<0>崧博出版事業有限公司</0>經銷品牌 —— 人文歷史與經典文本的再整理品牌。",

  "about.brandStory.imageTitle": "品牌故事",
  "about.brandStory.imageSubtitle": "以文字跨越時代",
  "about.brandStory.heading": "讓經典重新被閱讀",
  "about.brandStory.p1": "<0>複刻文化</0>為<1>崧博出版事業有限公司</1>經銷品牌，專注於歷史、人文社科、公版經典與小說類書籍的出版。",
  "about.brandStory.p2": "複刻二字的靈感來自於傳統印刷術中的「覆刻」概念 —— 將珍貴的古籍重新製版、印製，讓經典文本得以流傳。我們將這個概念延伸為品牌的核心理念：不只是複製，更是再創造；不只是重印，更是重新詮釋。",
  "about.brandStory.p3": "我們相信，經典不應只存在於學術殿堂的書架上。透過重新整理、詮釋與包裝，讓這些跨越時代的文本在當代煥發新生 —— 讓歷史成為可親近的對話，讓經典成為可閱讀的當下。",

  "about.mission.title": "使命",
  "about.mission.desc": "讓經典文本在當代重新被閱讀、被理解、被討論，搭建歷史人文知識與現代讀者之間的橋樑。",
  "about.vision.title": "願景",
  "about.vision.desc": "成為華文世界最具影響力的人文歷史與經典文本再整理品牌，建立完整的歷史人文知識生態系統。",
  "about.value.title": "價值",
  "about.value.desc": "學術嚴謹、內容可信、設計典藏。每一本出版品都經過嚴格的編輯審校，確保品質與深度。",

  "about.songbo.heading": "複刻文化 × 崧博出版",
  "about.songbo.p1": "<0>複刻文化</0>為崧博出版事業有限公司經銷品牌。崧博出版擁有二十餘年的專業出版經驗，在學術出版、教科書與文史類書籍領域具備深厚的編輯實力與通路資源。",
  "about.songbo.backHome": "回到首頁",

  "bookCard.viewOnSongbo": "崧博官網",

  "notFound.title": "此頁面尚未生成",
  "notFound.subtitle": "告訴我更多關於這個頁面的資訊，我就可以生成它",

  "lang.switchTo": "語言",

  "brand.imageAlt": "複刻文化 Fuko 品牌視覺"
};

export default zhTW;